import graphql__ffcdcc002c41dfea7b28 from "./__generated__/ContributionsDatavizFilters_participativeModule.graphql.js";import { graphql, useFragment } from "react-relay";
import { useDispatch } from "react-redux";
import { defineMessages } from "react-intl";

import ContributionsListFiltersLoader from "../ContributionsListFiltersLoader";
import { useResourcesList } from "../../../ResourcesList/resourcesList";
import { isResourcesListFiltered } from "../../../Utils/resourcesList";

import { clearAllFilters } from "../../../../reducers/resourcesList/search";
import { useFormatMessage } from "../../../Intl/Context";
import Button from "../../../Buttons/Button";
import Icon from "../../../Utils/Icon";
import Search from "../../../Filters/Search";
import ContributionsCountBadge from "../ContributionsCountBadge";
import ContributionsDatavizViewerFilters from "./ContributionsDatavizViewerFilters";

const ContributionsDatavizFilters = props => {
  const participativeModule = useFragment(
    ContributionsDatavizFilters_participativeModule,
    props.participativeModule
  );
  const { refetchFragment, refetchFragmentParent, children } = props;

  const { resourcesListKey, ...resourcesList } = useResourcesList();
  const hasSelectedFilters = isResourcesListFiltered(resourcesList);

  const dispatch = useDispatch();

  const resetFilters = () => {
    dispatch(clearAllFilters(resourcesListKey));
  };

  const t = useFormatMessage();
  const filterTitle = t(intlMessages.filter);
  const resetFilterLabel = t(intlMessages.resetFilter);

  return (
    <div className="box margin-bottom-xs padding-sm">
      <div className="margin-bottom-xs border-bottom">
        <div className="margin-bottom-xs">
          <h2 className="text-title-section d-inline-block">{filterTitle}</h2>

          {hasSelectedFilters && (
            <Button
              type="button"
              className="btn btn-primary btn-xs float-right margin-left-xs"
              onClick={resetFilters}
              label={resetFilterLabel}
              iconClassName="icon-close"
            />
          )}

          <ContributionsListFiltersLoader
            spinnerClassName="inline-spinner text-primary float-right align-middle"
            refetchFragment={refetchFragment}
            refetchFragmentParent={refetchFragmentParent}
          >
            <Icon className="text-title-section icon-filter text-primary float-right align-middle" />
          </ContributionsListFiltersLoader>
        </div>

        <Search className="margin-bottom-xs" />
        <ContributionsCountBadge className="margin-bottom-xs" />
      </div>

      {children}

      <ContributionsDatavizViewerFilters participativeModule={participativeModule} />
    </div>
  );
};

const ContributionsDatavizFilters_participativeModule = graphql__ffcdcc002c41dfea7b28;

export default ContributionsDatavizFilters;

const intlMessages = defineMessages({
  filter: {
    id: "participativeModule.contributionsDataviz.filters.filter",
    defaultMessage: "Filtrer"
  },
  resetFilter: {
    id: "participativeModule.contributionsDataviz.filters.resetFilter",
    defaultMessage: "effacer les filtres"
  }
});
